<template>
  <a-layout class="menu-content">
    <a-layout-sider width="280" style="background: #fff;padding:16px 0 16px 16px">
      <div class="content-panel itemBank-panel">
        <a-input-search
          v-model="searchValue"
          style="margin-bottom: 8px"
          placeholder="请输入题库名称关键字"
          @search="querySubjectBanks"
        />
        <a-button type="primary" v-action:add_bank @click="handleOpenBankModal()" block>新建题库</a-button>
        <!-- showIcon -->
        <a-list itemLayout="horizontal" :split="false" :dataSource="subjectBank">
          <a-list-item
            slot="renderItem"
            slot-scope="item, index"
            :class="[activeTab === index ? 'active' : '', 'bankList']"
            @click="changeBank(item, index)"
          >
            <a-list-item-meta>
              <!-- <span slot="title" style="margin-left:10px">{{ item.name }}</span> -->
              <span slot="title" class="es" style="margin-left:10px">
                <a-tooltip>
                  <template slot="title">
                    {{ item.name }}
                  </template>
                  {{ item.name }}
                </a-tooltip>
              </span>
            </a-list-item-meta>
            <div style="margin-right:10px">
              <a-tooltip>
                <template slot="title">
                  编辑
                </template>
                <a-icon
                  type="edit"
                  v-action:edit_bank
                  style="margin-right:10px;color:#1890ff"
                  @click="handleOpenBankModal(item)"
                />
              </a-tooltip>
              <a-popconfirm
                v-action:delete_bank
                :title="'确定要删除“' + item.name + '”题库吗?'"
                @confirm="handleDeleteBank(item.id)"
              >
                <a-tooltip>
                  <template slot="title">
                    删除
                  </template>
                  <a-icon type="delete" style="margin-right:10px;color:#1890ff" />
                </a-tooltip>
              </a-popconfirm>

              <a-upload
                :fileList="fileList"
                :showUploadList="false"
                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :beforeUpload="beforeUpload"
              >
                <a-tooltip>
                  <template slot="title">
                    导入
                  </template>
                  <a-icon type="import" v-action:import_subject style="margin-right:10px;color:#1890ff" />
                </a-tooltip>
              </a-upload>

              <a-tooltip>
                <template slot="title">
                  导出
                </template>
                <a-icon type="export" style="color:#1890ff" v-action:export_subject @click="handleExport(item)" />
              </a-tooltip>
            </div>
          </a-list-item>
        </a-list>
      </div>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content itemBank">
        <div class="tableContainer">
          <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
          <!-- 操作按钮-->
          <div class="table-operator" style="margin-bottom:10px">
            <a-button type="primary" v-action:add_subject @click="handleAddtItem" style="margin-right:10px">
              <a-icon type="plus" />新增题目</a-button
              >
            <a-button @click="handleDownload" style="margin-right:10px"> <a-icon type="download" />模板下载 </a-button>
            <a-popconfirm
              :title="deleteConfirmInfo === '' ? '请先选择题目' : '确定要删除“' + deleteConfirmInfo + '”吗?'"
              @visibleChange="handleVisibleChange"
              @confirm="handleDeleteSubjects()"
              v-action:delete_subject
            >
              <a-button> <a-icon type="delete" />批量删除</a-button>
            </a-popconfirm>
          </div>
          <a-table
            :columns="table.columns"
            :rowKey="record => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            style="margin-top:10px"
            :scroll="{ x: 1000,y:y}"
            size="small"
          >
            <template slot="actions" slot-scope="text, record">
              <div class="table-operator">
                <a v-action:edit_subject @click="handleEditSubject(record)" style="margin-right:15px;">编辑</a>

                <a-popconfirm
                  title="确定要删除这道题目吗?"
                  v-action:delete_subject
                  @confirm="handleDeleteSubjects(record.id)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </a-layout-content>

    <!--查看弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>

    <a-modal :title="bankTitle" :width="400" :visible="visible" :maskClosable="false" @cancel="bankClose()">
      <template slot="footer">
        <a-button key="back" @click="bankClose()">取消</a-button>
        <a-button key="submit" type="primary" @click="handleSubmitBank">
          确定
        </a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="48">
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="题库名称" hasFeedback>
              <a-input
                autocomplete="off"
                v-decorator="[
                  'name',
                  {
                    validateTrigger: ['blur'],
                    rules: [
                      { required: true, message: '请输入题库名称' },
                      {
                        pattern: /^[^\s]*$/,
                        message: '题库名称不能包含空格！'
                      },
                      {
                        max: 255,
                        message: '最多可输入255个字符'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="22">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback>
              <a-textarea
                :rows="4"
                autocomplete="off"
                v-decorator="[
                  'remark',
                  {
                    validateTrigger: ['blur'],
                    rules: [
                      {
                        max: 500,
                        message: '最多可输入500个字符'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-layout>
</template>

<script>
import { mapActions } from 'vuex'

import { getDictInfoByCode } from '@/api/dict'
import {
  getSubjectBanks,
  controlSubjectBanks,
  deleteSubjectBanks,
  getSubjects,
  deleteSubjects,
  importSubjects,
  exportSubjects,
  downloadSubjects
} from '@/api/subject'

import searchForm from './modules/searchForm'
import editModal from './modules/editModal'

export default {
  components: {
    searchForm,
    editModal
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'bank_form' })
  },
  data () {
    const screenWidth = document.body.clientWidth
    var y = screenWidth > 1366 ? 600 : 290

    return {
      y,
      cardOption: {}, // card相关属性设置
      searchFormModel: {}, // 搜索form中的参数
      searchModel: {}, // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      selectedRowKeys: [],
      selectedRow: [],
      showSelectedRow: [],
      deleteConfirmInfo: '',
      pagination: {
        paging: true,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      searchValue: '',
      table: {
        data: [],
        columns: [
          {
            title: '题目',
            width: 200,
            align: 'center',
            dataIndex: 'title'
          },
          {
            title: '题型',
            width: 100,
            align: 'center',
            dataIndex: 'typeName'
          },
          {
            title: '选项',
            align: 'center',
            dataIndex: 'options'
          },
          {
            title: '正确答案',
            width: 200,
            align: 'center',
            dataIndex: 'rights'
          },
          {
            title: '操作',
            width: 100,
            align: 'center',
            fixed: 'right',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        loading: false
      },
      formIptTitle: {
        formTitle: '菜单详情'
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      bankItem: {},
      bankId: null,
      bankTitle: '',
      visible: false,
      subjectBank: [],
      activeTab: 0,
      fileList: []
    }
  },
  computed: {
    hasSelected () {
      return this.selectedRowKeys.length > 0
    }
  },
  mounted () {
    this.initDictData()
    this.querySubjectBanks()
  },
  methods: {
    ...mapActions(['handleSubjectType', 'handleSubjectBankId']),
    // paperDownload () {
    //   // 试卷下载
    //   paperDownload().then(res => {
    //     console.log('试卷下载成功', res)
    //   }).catch(error => {
    //     console.log('试卷下载失败', error)
    //   })
    // },
    changeBank (item, index) {
      this.activeTab = index
      this.bankItem = item
      this.handleSubjectBankId(item.id)
      this.setSearchCondition()
    },
    // 初始化字典数据
    initDictData () {
      // 题目类型
      getDictInfoByCode({ pCode: 'TRAIN_SUBJECT_TYPE' }).then(res => {
        // console.log('题目类型', res.data)
        this.handleSubjectType(res.data)
      })
    },
    // 获取题库列表
    querySubjectBanks () {
      const query = {
        status: 1
      }
      if (this.searchValue) {
        query.name = this.searchValue.trim()
      }
      getSubjectBanks(query).then(res => {
        if (res.data.length) {
          this.subjectBank = res.data
          this.bankItem = res.data[0]
          this.handleSubjectBankId(this.bankItem.id)
          this.setSearchCondition()
        } else {
          this.subjectBank = []
        }
      })
    },
    // 打开题库修改编辑页面
    handleOpenBankModal (item) {
      this.visible = true
      if (item) {
        this.bankId = item.id
        this.bankTitle = '修改题库'
        this.$nextTick(() => {
          this.form.setFieldsValue({
            name: item.name,
            remark: item.remark
          })
        })
      } else {
        this.bankTitle = '新增题库'
        this.bankId = null
      }
    },
    // 提交题库的信息
    handleSubmitBank (e) {
      e.preventDefault()

      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }

          if (this.bankId) params.id = this.bankId
          if (!params.remark) delete params.remark
          console.log('params', params)

          controlSubjectBanks(params).then(res => {
            if (res.status === 0) {
              if (this.bankId) {
                this.$message.success('修改成功')
              } else {
                this.$message.success('新增成功')
              }
              this.visible = false
              this.form.resetFields()
              this.querySubjectBanks()
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
    },
    // 删除题库
    handleDeleteBank (id) {
      deleteSubjectBanks(id).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功!')
          this.showSelectedRow = []
          this.querySubjectBanks()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    bankClose () {
      this.visible = false
      this.form.resetFields()
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...searchFormModel }
      this.initTableData()
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination
      }
      this.initTableData()
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true
      console.log('查询条件', this.searchModel)

      this.searchModel.subjectBankId = this.bankItem.id

      getSubjects(this.searchModel).then(res => {
        console.log('res', res)

        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
          this.table.loading = false
        }
      })
    },
    handleAddtItem () {
      this.$refs.editModal.setTitle('新增题目')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.editModal.open(true)
    },
    handleEditSubject (model) {
      this.$refs.editModal.setTitle('编辑题目')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)
      this.handleSubjectBankId(model.subjectBankId)
      this.$refs.editModal.open(true)
    },
    // 导出
    handleExport (item) {
      exportSubjects(item.id).then(res => {
        var blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = `题库-${item.name}.xlsx`
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      })
    },
    // 批量删除
    handleVisibleChange (visible) {
      if (!visible) {
        return
      }

      let confirmString = ''
      this.showSelectedRow.forEach(item => {
        confirmString += item.title + ','
      })
      this.deleteConfirmInfo = confirmString.substr(0, confirmString.length - 1)
    },
    handleDeleteSubjects (item) {
      let query
      if (item) {
        query = {
          ids: item.toString()
        }
      } else {
        if (this.selectedRowKeys.length === 0) {
          this.$message.error('请先选择一个题目!')
          return
        }
        query = {
          ids: this.selectedRowKeys.join(',')
        }
      }
      deleteSubjects(query).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          this.showSelectedRow = []
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 导入题库
    beforeUpload (file) {
      console.log('file', file)

      var fileName = file.name.split('.')
      var type = fileName[fileName.length - 1]

      if (type === 'xls' || type === 'xlsx') {
        this.fileList = [file]
      } else {
        this.$message.error('只支持xls、xlsx格式的文件')
      }

      this.handleUpload()
    },
    handleUpload () {
      const { fileList } = this
      const formData = new FormData()

      fileList.forEach(file => {
        formData.append('file', file)
      })

      importSubjects(formData, this.bankItem.id)
        .then(res => {
          console.log('res', res)

          if (res.status === 0) {
            this.$message.success(res.info.message)
            this.initTableData()
          } else {
            this.$message.error(res.info.message, 5)
          }

          this.fileList = []
        })
        .catch(err => {
          this.$message.error('upload failed.')
        })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRow[this.pagination.pageNum] = selectedRows

      const showSelectedRow = []
      for (const item of this.selectedRow) {
        if (item) {
          for (const data of item) {
            showSelectedRow.push(data)
          }
        }
      }
      this.showSelectedRow = showSelectedRow
    },
    // 下载模板
    handleDownload () {
      downloadSubjects().then(response => {
        console.log('response', response)
        /* 火狐谷歌的文件下载方式 */
        var blob = new Blob([response])
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = '题目模板.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      })
    }
  }
}
</script>

<style lang="less">
@media screen and (max-width: 1366px) {
  .itemBank-panel {
    .ant-list {
      height: 320px !important;
      overflow-y: auto;
    }
  }
}

.itemBank-panel {
  .ant-list {
    height: 68vh;
    overflow-y: auto;
  }
}

.bankList {
  cursor: pointer;
  &.active {
    background: #e6f7ff;
  }

  .ant-list-item-meta-title{
    width: 150px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
  }
}

.ant-layout-content .ant-layout .content.itemBank {
  overflow: inherit;
}
</style>
